export default __webpack_public_path__ + "static/media/remodel7.606fcd61.png";